module.exports = __webpack_public_path__ + "img/iRomance-success.64642f0e.png";